/**
 * Query params that are kept on the pageview URLs sent to Fathom.
 *
 * Everything else is stripped. Several routes carry credentials in the query
 * string (`/login?magicAuthToken=…`, `/verifyemail?t=…`, `/register?email=…`),
 * and those must never be handed to a third-party analytics service. The
 * allow-list keeps campaign attribution working without leaking secrets.
 */
const ALLOWED_QUERY_PARAMS: RegExp[] = [
  /^utm_[a-z]+$/i,
  /^ref$/i,
  /^source$/i,
  /^gclid$/i,
  /^fbclid$/i,
];

/**
 * Builds the absolute URL reported to Fathom for a pageview.
 *
 * @param origin   e.g. `https://app.ullr.ski`
 * @param pathname router pathname, already including any trailing slash
 * @param search   raw query string, with or without the leading `?`
 */
export function buildPageviewUrl(
  origin: string,
  pathname: string,
  search = ''
): string {
  const incoming = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search
  );

  const kept = new URLSearchParams();
  incoming.forEach((value, key) => {
    if (ALLOWED_QUERY_PARAMS.some((allowed) => allowed.test(key))) {
      kept.append(key, value);
    }
  });

  const query = kept.toString();
  return `${origin}${pathname}${query ? `?${query}` : ''}`;
}
